import axios from 'axios'
// import { setRoutines } from '../reducers/routinesReducer'
import Sweetalert from 'sweetalert2'
import * as actions from '../reducers/api';
import { setLoading } from '../reducers/authReducer'

const api = ({dispatch}) => next => async action => {
    if(action.type!== actions.apiCallBegan.type) return next(action)
    next(action);
    const {url,method,data,onSuccess,onError,token} = action.payload;
    // console.log("API Middleware store:", onSuccess);
    try{
        dispatch(setLoading(true));
        const base_url = process.env.REACT_APP_API_ENDPOINT + "api";
        var response = await axios.request({
            baseURL: base_url,
            // baseURL:"http://rulesbackend.gvqdev.me/api",
            url,
            method,
            data,
            headers:{
                "Content-type":"application/json",
                "Authorization":`Bearer ${token}`
            }
        });
        response = response.data;
        
        if(response.result)
        {
            
            if(response.msg)
            {
                Sweetalert.fire({
                    icon: 'success',
                    text: response.msg,
                })
            }

            //To show resonse of Routine's run action
            if(url.includes("routine/run/") && response.data.output)
            {
                var html = `<div class="sweetalert-body green">Routine Ran Successfully</div>`;
                html += `<div class="sweetalert-body blue"><br> <br>`+JSON.stringify(response.data.output)+` <br></div>`;
                Sweetalert.fire({
                  toast: false,
                  showConfirmButton: false,
                  // timer: 3000,
                  timerProgressBar: true,
                  title: 'Output',
                  html: html,
                  icon:"success"
                })
            }
            // if(onSuccess) dispatch({type:onSuccess,payload:response.data.data})
            // dispatch(actions.apiCallSuccess(response.data.data));
            if(onSuccess) dispatch(onSuccess(response.data))
        
        }else{
            if(response.msg)
            {
                Sweetalert.fire({
                    icon: 'error',
                    text: response.msg,
                  })
            }

            var result = (typeof response!="object")?response:JSON.stringify(response);
            var html = `<div class="sweetalert-body bg-danger">Routine is in Debug Mode</div>`;
            html  += `<div class="sweetalert-body bg-info">`+result+`</div>`;
            Sweetalert.fire({
                toast: false,
                showConfirmButton: true,
                // timer: 3000,
                timerProgressBar: true,
                title: 'Output',
                html: html,
                icon:"warning"
              })

        }
        dispatch(setLoading(false));
    }catch(error)
    {
        Sweetalert.fire({
            icon: 'error',
            text: error,
          })

        dispatch(actions.apiCallFailed(error));

        if(onError) dispatch({type:onError,payload:error})
    }
    
}

export default api;